import { cartClient } from '../common/cartClient';
import type {
  CreateGorgiasAuthenticatedSessionIdentityResponse,
  CreateGorgiasGuestEmailChallengeRequest,
  CreateGorgiasGuestEmailChallengeResponse,
  VerifyGorgiasGuestEmailChallengeRequest,
  VerifyGorgiasGuestEmailChallengeResponse,
} from './utils/types';

class GorgiasSessionIdentityAPIClient {
  public async createGuestEmailChallenge(
    payload: CreateGorgiasGuestEmailChallengeRequest,
  ): Promise<CreateGorgiasGuestEmailChallengeResponse> {
    return await cartClient.post('/gorgias/sessionIdentity/guestEmailChallenge', payload).then((res) => res.data);
  }

  public async verifyGuestEmailChallenge(
    payload: VerifyGorgiasGuestEmailChallengeRequest,
  ): Promise<VerifyGorgiasGuestEmailChallengeResponse> {
    return await cartClient
      .post('/gorgias/sessionIdentity/guestEmailChallenge/verify', payload)
      .then((res) => res.data);
  }

  public async createAuthenticatedSessionIdentity(): Promise<CreateGorgiasAuthenticatedSessionIdentityResponse> {
    return await cartClient.post('/gorgias/sessionIdentity/authenticatedSession', {}).then((res) => res.data);
  }
}

export const gorgiasSessionIdentityAPIClient = new GorgiasSessionIdentityAPIClient();
